// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationMerchantShipOrderPath = 'M49 12.5H23V77c0 5.799 4.701 10.5 10.5 10.5h56c5.799 0 10.5-4.701 10.5-10.5V12.5H49zm0 7H30V77a3.5 3.5 0 003.308 3.495l.192.005h56A3.5 3.5 0 0093 77V19.5H74v17.886L61.5 31.83 49 37.386V19.5zm18 0H56v7.113l5.5-2.443 5.5 2.444V19.5zm7.127 22.74l5.346 4.52-21.07 24.921-12.09-12.22 4.975-4.923 6.709 6.781 16.13-19.079zM19 66.5v-7H0v7h19zm0-19v7H5v-7h14zm0-5v-7h-9v7h9z';
var IllustrationMerchantShipOrder = baseIllustration('IllustrationMerchantShipOrder', {
  getPath: () => IllustrationMerchantShipOrderPath
}, 'ColoredIllustrationMerchantShipOrder');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationMerchantShipOrder;
//# sourceMappingURL=index.js.map